export default "__VITE_ASSET__BnFggMeH__"